import React from 'react'
import { PageTitleContainer, PageTitleText } from './PageLayout.styles'

export const PageTitle = ({ title }: { title: string }): JSX.Element => {
  return (
    <PageTitleContainer>
      <PageTitleText>{title}</PageTitleText>
    </PageTitleContainer>
  )
}
